// @ts-nocheck
import pagesReducer, { PagesActions } from "@store/Framework/Store/Starter/Pages/PagesReducer";
import { combineReducers } from "redux";

const starterReducer = combineReducers({
    pages: pagesReducer,
});

export type StarterActions = PagesActions;

export default starterReducer;
